import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { User } from 'src/app/_models/user';
import { NotificationService } from 'src/app/_services/notification.service';
import { UserService } from 'src/app/_services/user.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MyErrorStateMatcher } from 'src/app/_services/form-group-validation.service';

export interface DialogData {
  user: User;
}

@Component({
  selector: 'app-changeDialog',
  templateUrl: './changeDialog.component.html'
})

export class ChangeDialogComponent implements OnInit {
  matcher = new MyErrorStateMatcher();
  form: UntypedFormGroup;
  constructor(public dialogRef: MatDialogRef<ChangeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private userService: UserService,
    private notify: NotificationService, private fb: UntypedFormBuilder, private router: Router) { }
  model: any = {};

  ngOnInit() {
    this.createForm();
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  change() {
    if (this.form.valid) {
      this.model.username = this.data.user.username;
      this.userService.changePassword(this.model).subscribe(() => {
        this.notify.success('Uspesno promenjena lozinka');
        this.dialogRef.close();
        if (this.data.user.role === 0) {
          this.router.navigate(['/dashboard']);
        } else if (this.data.user.role === 1) {
          this.router.navigate(['/vehicles']);
        } else if (this.data.user.role === 2) {
          this.router.navigate(['/freeModems']);
        }
      }, error => {
        this.notify.error('Neuspesna izmena, proverite staru lozinku!');
      });
    } else {
      this.validateAllFormFields(this.form);
      this.notify.error('Lozinke se ne poklapaju');
    }
  }
  createForm() {
    this.form = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', [Validators.required]],
      confirmNewPassword: ['', Validators.required],
    }, { validators: [this.passwordMatchValidator] });
  }

  passwordMatchValidator(g: UntypedFormGroup) {
    return g.get('newPassword').value === g.get('confirmNewPassword').value ? null : { 'mismatch': true };
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched();
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}
